/**
 * Componente copiado de ADF 5.0.0 y adaptado a nuestras necesidades
 */

import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'smt-search-filter-menu-card',
  templateUrl: './search-filter-menu-card.component.html',
  styleUrls: ['./search-filter-menu-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SMTSearchFilterMenuCardComponent {
    @Input() showActions!: boolean;

    @Output()
    closeMenu = new EventEmitter();

    onClose() {
        this.closeMenu.emit();
    }
}